import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from "../../axios-client";
export const SendInquiry = createAsyncThunk(
  "inquiry/sendInquiry",
  async (params, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post("need/createInquiry", params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);
const initialState = {
  needId: null,
  enquiryStep: 1,
  createdBy: null,
  createdEmail: "",
  Status: 0,
  engagedCouple: 1,
  enquiry: 1,
  Photo: "",
  serviceId: null,
  // -------------------- First Step  -------------------
  Title: "",
  Zipcode: "",
  Description: "",
  Email: "",
  countryCode: "",
  Phone: "",
  alternativePhoneOne: "",
  FullName: "",
  // -------------------- Second Step ----------------------
  eventDetails: [],
  // -------------------- Third Step ----------------------
  otherVendors: [],
  noOtherVendors: 0,
};
const secondState = {
  submiting: false,
  errorSubmit: null,
};
const InquirySlice = createSlice({
  name: "inquiry",
  initialState,
  reducers: {
    resetInquiryState: (state) => initialState,
    setEnquiryStep(state, action) {
      state.enquiryStep = action.payload;
    },
    setCreatedBy(state, action) {
      state.createdBy = action.payload;
    },
    setFullName(state, action) {
      state.FullName = action.payload;
    },
    setCreatedEmail(state, action) {
      state.createdEmail = action.payload;
    },
    setTitle(state, action) {
      state.Title = action.payload;
    },
    setZipcode(state, action) {
      state.Zipcode = action.payload;
    },
    setServiceId(state, action) {
      state.serviceId = action.payload;
    },
    setDescription(state, action) {
      state.Description = action.payload;
    },
    setEmail(state, action) {
      state.Email = action.payload;
    },
    setCountryCode(state, action) {
      state.countryCode = action.payload;
    },
    setPhone(state, action) {
      state.Phone = action.payload;
    },
    setAlternativePhoneOne(state, action) {
      state.alternativePhoneOne = action.payload;
    },
    setEventDetails(state, action) {
      state.eventDetails = action.payload;
    },
    setOtherVendors(state, action) {
      state.otherVendors = action.payload;
    },
    setNoOtherVendors(state, action) {
      state.noOtherVendors = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(SendInquiry.pending, (state) => {})
      .addCase(SendInquiry.fulfilled, (state, action) => {
        state.needId = action.payload && action.payload?.Data?.id;
      })
      .addCase(SendInquiry.rejected, (state, action) => {});
  },
});
export const {
  resetInquiryState,
  setEnquiryStep,
  setServiceId,
  setCreatedBy,
  setFullName,
  setCreatedEmail,
  setTitle,
  setZipcode,
  setDescription,
  setEmail,
  setCountryCode,
  setPhone,
  setAlternativePhoneOne,
  setEventDetails,
  setOtherVendors,
  setNoOtherVendors,
} = InquirySlice.actions;
export default InquirySlice.reducer;
